import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type LoadMailsQueryVariables = {
  filter?: Types.Maybe<Types.MailFilterType>,
  provingId?: Types.Maybe<Types.Scalars['String']>
};


export type LoadMailsQuery = (
  { __typename?: 'Query' }
  & { mails: Array<(
    { __typename?: 'Mail' }
    & Pick<Types.Mail, '_id' | 'subject' | 'created' | 'receivedAt' | 'sentAt' | 'isRead'>
    & { proving: Types.Maybe<(
      { __typename?: 'Proving' }
      & Pick<Types.Proving, '_id' | 'id'>
    )>, to: Array<(
      { __typename?: 'MailAddress' }
      & Pick<Types.MailAddress, 'address'>
    )>, cc: Types.Maybe<Array<(
      { __typename?: 'MailAddress' }
      & Pick<Types.MailAddress, 'address'>
    )>>, from: Types.Maybe<(
      { __typename?: 'MailAddress' }
      & Pick<Types.MailAddress, 'address'>
    )>, attachments: Types.Maybe<Array<(
      { __typename?: 'MailAttachment' }
      & Pick<Types.MailAttachment, 'name'>
    )>> }
  )> }
);

export type LoadMailsWithBodyQueryVariables = {
  filter?: Types.Maybe<Types.MailFilterType>,
  provingId?: Types.Maybe<Types.Scalars['String']>
};


export type LoadMailsWithBodyQuery = (
  { __typename?: 'Query' }
  & { mails: Array<(
    { __typename?: 'Mail' }
    & Pick<Types.Mail, '_id' | 'subject' | 'created' | 'receivedAt' | 'sentAt' | 'body' | 'isRead'>
    & { proving: Types.Maybe<(
      { __typename?: 'Proving' }
      & Pick<Types.Proving, '_id' | 'id'>
    )>, to: Array<(
      { __typename?: 'MailAddress' }
      & Pick<Types.MailAddress, 'address'>
    )>, cc: Types.Maybe<Array<(
      { __typename?: 'MailAddress' }
      & Pick<Types.MailAddress, 'address'>
    )>>, from: Types.Maybe<(
      { __typename?: 'MailAddress' }
      & Pick<Types.MailAddress, 'address'>
    )>, attachments: Types.Maybe<Array<(
      { __typename?: 'MailAttachment' }
      & Pick<Types.MailAttachment, 'name' | 'uri'>
    )>> }
  )> }
);

export type LoadMailQueryVariables = {
  _id: Types.Scalars['ID']
};


export type LoadMailQuery = (
  { __typename?: 'Query' }
  & { mail: Types.Maybe<(
    { __typename?: 'Mail' }
    & Pick<Types.Mail, '_id' | 'subject' | 'created' | 'receivedAt' | 'sentAt' | 'body' | 'isRead'>
    & { proving: Types.Maybe<(
      { __typename?: 'Proving' }
      & Pick<Types.Proving, '_id' | 'id'>
    )>, to: Array<(
      { __typename?: 'MailAddress' }
      & Pick<Types.MailAddress, 'address'>
    )>, cc: Types.Maybe<Array<(
      { __typename?: 'MailAddress' }
      & Pick<Types.MailAddress, 'address'>
    )>>, from: Types.Maybe<(
      { __typename?: 'MailAddress' }
      & Pick<Types.MailAddress, 'address'>
    )>, attachments: Types.Maybe<Array<(
      { __typename?: 'MailAttachment' }
      & Pick<Types.MailAttachment, 'name' | 'uri'>
    )>> }
  )> }
);

export type MailChangesQueryVariables = {
  provingId: Types.Scalars['String'],
  participants: Array<Types.Scalars['String']>,
  paths: Array<Types.Scalars['String']>
};


export type MailChangesQuery = (
  { __typename?: 'Query' }
  & { mailChanges: Array<(
    { __typename?: 'ProvingChange' }
    & Pick<Types.ProvingChange, '_id'>
    & { change: (
      { __typename?: 'ProvingChangeDetails' }
      & Pick<Types.ProvingChangeDetails, 'key' | 'path' | 'value' | 'oldValue'>
    ) }
  )> }
);

export type CreateMailMutationVariables = {
  provingId?: Types.Maybe<Types.Scalars['String']>,
  input?: Types.Maybe<Types.MailInsertType>,
  attachments?: Types.Maybe<Array<Types.MailAttachmentInput>>
};


export type CreateMailMutation = (
  { __typename?: 'Mutation' }
  & { createMail: (
    { __typename?: 'Mail' }
    & Pick<Types.Mail, '_id'>
  ) }
);

export type UpdateMailMutationVariables = {
  id: Types.Scalars['ID'],
  update: Types.MailUpdateInput
};


export type UpdateMailMutation = (
  { __typename?: 'Mutation' }
  & { updateMail: (
    { __typename?: 'Mail' }
    & Pick<Types.Mail, '_id'>
  ) }
);

export type DeleteMailMutationVariables = {
  filter?: Types.Maybe<Types.Scalars['ID']>
};


export type DeleteMailMutation = (
  { __typename?: 'Mutation' }
  & Pick<Types.Mutation, 'deleteMail'>
);

export type DeleteMailsMutationVariables = {
  ids: Array<Types.Scalars['String']>
};


export type DeleteMailsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Types.Mutation, 'deleteMails'>
);

export type LoadMailProvingPickerQueryVariables = {};


export type LoadMailProvingPickerQuery = (
  { __typename?: 'Query' }
  & { provings: Array<(
    { __typename?: 'Proving' }
    & Pick<Types.Proving, '_id' | 'id'>
  )> }
);

export type GenerateMailFromTemplateMutationVariables = {
  provingId: Types.Scalars['ID'],
  templateId: Types.Scalars['ID'],
  context?: Types.Maybe<Types.Scalars['JSON']>
};


export type GenerateMailFromTemplateMutation = (
  { __typename?: 'Mutation' }
  & { generateMailFromTemplate: (
    { __typename?: 'MailTemplateRendered' }
    & Pick<Types.MailTemplateRendered, 'to' | 'cc' | 'subject' | 'body'>
  ) }
);

export const LoadMailsDocument = gql`
    query LoadMails($filter: MailFilterType, $provingId: String) {
  mails(filter: $filter, provingId: $provingId, pagination: {limit: 500}) {
    _id
    proving {
      _id
      id
    }
    to {
      address
    }
    cc {
      address
    }
    from {
      address
    }
    subject
    created
    receivedAt
    sentAt
    attachments {
      name
    }
    isRead
  }
}
    `;

    export function useLoadMailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LoadMailsQuery, LoadMailsQueryVariables>) {
      return ApolloReactHooks.useQuery<LoadMailsQuery, LoadMailsQueryVariables>(LoadMailsDocument, baseOptions);
    };
      export function useLoadMailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LoadMailsQuery, LoadMailsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<LoadMailsQuery, LoadMailsQueryVariables>(LoadMailsDocument, baseOptions);
      };
      
export type LoadMailsQueryHookResult = ReturnType<typeof useLoadMailsQuery>;
export type LoadMailsQueryResult = ApolloReactCommon.QueryResult<LoadMailsQuery, LoadMailsQueryVariables>;
export const LoadMailsWithBodyDocument = gql`
    query LoadMailsWithBody($filter: MailFilterType, $provingId: String) {
  mails(filter: $filter, provingId: $provingId, pagination: {limit: 500}) {
    _id
    proving {
      _id
      id
    }
    to {
      address
    }
    cc {
      address
    }
    from {
      address
    }
    subject
    created
    receivedAt
    sentAt
    body
    attachments {
      name
      uri
    }
    isRead
  }
}
    `;

    export function useLoadMailsWithBodyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LoadMailsWithBodyQuery, LoadMailsWithBodyQueryVariables>) {
      return ApolloReactHooks.useQuery<LoadMailsWithBodyQuery, LoadMailsWithBodyQueryVariables>(LoadMailsWithBodyDocument, baseOptions);
    };
      export function useLoadMailsWithBodyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LoadMailsWithBodyQuery, LoadMailsWithBodyQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<LoadMailsWithBodyQuery, LoadMailsWithBodyQueryVariables>(LoadMailsWithBodyDocument, baseOptions);
      };
      
export type LoadMailsWithBodyQueryHookResult = ReturnType<typeof useLoadMailsWithBodyQuery>;
export type LoadMailsWithBodyQueryResult = ApolloReactCommon.QueryResult<LoadMailsWithBodyQuery, LoadMailsWithBodyQueryVariables>;
export const LoadMailDocument = gql`
    query LoadMail($_id: ID!) {
  mail(_id: $_id) {
    _id
    proving {
      _id
      id
    }
    to {
      address
    }
    cc {
      address
    }
    from {
      address
    }
    subject
    created
    receivedAt
    sentAt
    body
    attachments {
      name
      uri
    }
    isRead
  }
}
    `;

    export function useLoadMailQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LoadMailQuery, LoadMailQueryVariables>) {
      return ApolloReactHooks.useQuery<LoadMailQuery, LoadMailQueryVariables>(LoadMailDocument, baseOptions);
    };
      export function useLoadMailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LoadMailQuery, LoadMailQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<LoadMailQuery, LoadMailQueryVariables>(LoadMailDocument, baseOptions);
      };
      
export type LoadMailQueryHookResult = ReturnType<typeof useLoadMailQuery>;
export type LoadMailQueryResult = ApolloReactCommon.QueryResult<LoadMailQuery, LoadMailQueryVariables>;
export const MailChangesDocument = gql`
    query MailChanges($provingId: String!, $participants: [String!]!, $paths: [String!]!) {
  mailChanges(provingId: $provingId, participants: $participants, paths: $paths) {
    _id
    change {
      key
      path
      value
      oldValue
    }
  }
}
    `;

    export function useMailChangesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MailChangesQuery, MailChangesQueryVariables>) {
      return ApolloReactHooks.useQuery<MailChangesQuery, MailChangesQueryVariables>(MailChangesDocument, baseOptions);
    };
      export function useMailChangesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MailChangesQuery, MailChangesQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<MailChangesQuery, MailChangesQueryVariables>(MailChangesDocument, baseOptions);
      };
      
export type MailChangesQueryHookResult = ReturnType<typeof useMailChangesQuery>;
export type MailChangesQueryResult = ApolloReactCommon.QueryResult<MailChangesQuery, MailChangesQueryVariables>;
export const CreateMailDocument = gql`
    mutation CreateMail($provingId: String, $input: MailInsertType, $attachments: [MailAttachmentInput!]) {
  createMail(provingId: $provingId, input: $input, attachments: $attachments) {
    _id
  }
}
    `;
export type CreateMailMutationFn = ApolloReactCommon.MutationFunction<CreateMailMutation, CreateMailMutationVariables>;

    export function useCreateMailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMailMutation, CreateMailMutationVariables>) {
      return ApolloReactHooks.useMutation<CreateMailMutation, CreateMailMutationVariables>(CreateMailDocument, baseOptions);
    };
export type CreateMailMutationHookResult = ReturnType<typeof useCreateMailMutation>;
export type CreateMailMutationResult = ApolloReactCommon.MutationResult<CreateMailMutation>;
export type CreateMailMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateMailMutation, CreateMailMutationVariables>;
export const UpdateMailDocument = gql`
    mutation UpdateMail($id: ID!, $update: MailUpdateInput!) {
  updateMail(id: $id, update: $update) {
    _id
  }
}
    `;
export type UpdateMailMutationFn = ApolloReactCommon.MutationFunction<UpdateMailMutation, UpdateMailMutationVariables>;

    export function useUpdateMailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMailMutation, UpdateMailMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdateMailMutation, UpdateMailMutationVariables>(UpdateMailDocument, baseOptions);
    };
export type UpdateMailMutationHookResult = ReturnType<typeof useUpdateMailMutation>;
export type UpdateMailMutationResult = ApolloReactCommon.MutationResult<UpdateMailMutation>;
export type UpdateMailMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateMailMutation, UpdateMailMutationVariables>;
export const DeleteMailDocument = gql`
    mutation DeleteMail($filter: ID) {
  deleteMail(filter: {_id: {EQ: $filter}})
}
    `;
export type DeleteMailMutationFn = ApolloReactCommon.MutationFunction<DeleteMailMutation, DeleteMailMutationVariables>;

    export function useDeleteMailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMailMutation, DeleteMailMutationVariables>) {
      return ApolloReactHooks.useMutation<DeleteMailMutation, DeleteMailMutationVariables>(DeleteMailDocument, baseOptions);
    };
export type DeleteMailMutationHookResult = ReturnType<typeof useDeleteMailMutation>;
export type DeleteMailMutationResult = ApolloReactCommon.MutationResult<DeleteMailMutation>;
export type DeleteMailMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteMailMutation, DeleteMailMutationVariables>;
export const DeleteMailsDocument = gql`
    mutation DeleteMails($ids: [String!]!) {
  deleteMails(ids: $ids)
}
    `;
export type DeleteMailsMutationFn = ApolloReactCommon.MutationFunction<DeleteMailsMutation, DeleteMailsMutationVariables>;

    export function useDeleteMailsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMailsMutation, DeleteMailsMutationVariables>) {
      return ApolloReactHooks.useMutation<DeleteMailsMutation, DeleteMailsMutationVariables>(DeleteMailsDocument, baseOptions);
    };
export type DeleteMailsMutationHookResult = ReturnType<typeof useDeleteMailsMutation>;
export type DeleteMailsMutationResult = ApolloReactCommon.MutationResult<DeleteMailsMutation>;
export type DeleteMailsMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteMailsMutation, DeleteMailsMutationVariables>;
export const LoadMailProvingPickerDocument = gql`
    query LoadMailProvingPicker {
  provings(filter: {status: {NIN: [8, 9, 10]}}) {
    _id
    id
  }
}
    `;

    export function useLoadMailProvingPickerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LoadMailProvingPickerQuery, LoadMailProvingPickerQueryVariables>) {
      return ApolloReactHooks.useQuery<LoadMailProvingPickerQuery, LoadMailProvingPickerQueryVariables>(LoadMailProvingPickerDocument, baseOptions);
    };
      export function useLoadMailProvingPickerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LoadMailProvingPickerQuery, LoadMailProvingPickerQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<LoadMailProvingPickerQuery, LoadMailProvingPickerQueryVariables>(LoadMailProvingPickerDocument, baseOptions);
      };
      
export type LoadMailProvingPickerQueryHookResult = ReturnType<typeof useLoadMailProvingPickerQuery>;
export type LoadMailProvingPickerQueryResult = ApolloReactCommon.QueryResult<LoadMailProvingPickerQuery, LoadMailProvingPickerQueryVariables>;
export const GenerateMailFromTemplateDocument = gql`
    mutation GenerateMailFromTemplate($provingId: ID!, $templateId: ID!, $context: JSON) {
  generateMailFromTemplate(templateId: $templateId, provingId: $provingId, context: $context) {
    to
    cc
    subject
    body
  }
}
    `;
export type GenerateMailFromTemplateMutationFn = ApolloReactCommon.MutationFunction<GenerateMailFromTemplateMutation, GenerateMailFromTemplateMutationVariables>;

    export function useGenerateMailFromTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateMailFromTemplateMutation, GenerateMailFromTemplateMutationVariables>) {
      return ApolloReactHooks.useMutation<GenerateMailFromTemplateMutation, GenerateMailFromTemplateMutationVariables>(GenerateMailFromTemplateDocument, baseOptions);
    };
export type GenerateMailFromTemplateMutationHookResult = ReturnType<typeof useGenerateMailFromTemplateMutation>;
export type GenerateMailFromTemplateMutationResult = ApolloReactCommon.MutationResult<GenerateMailFromTemplateMutation>;
export type GenerateMailFromTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateMailFromTemplateMutation, GenerateMailFromTemplateMutationVariables>;